import { computed, ref } from "@vue/composition-api";

import { Page, PageLocationType } from "@scrile/api-provider/dist/api/PageProvider";
import providers from "@/lib/api";

export const useStaticPages = () => {
  const pages = ref<Page[]>([]);

  const moreMenuPages = computed<Page[]>(() =>
    pages.value.filter(page => page.visible && page.location === PageLocationType.MORE_MENU)
  );

  const termsPages = computed<Page[]>(() =>
    pages.value.filter(page => page.visible && page.location === PageLocationType.TERMS)
  );

  const getPages = async () => {
    pages.value = await providers.PageProvider.find();
  };

  return {
    pages,
    moreMenuPages,
    termsPages,
    getPages,
  };
};
